import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { TIME_SEPARATOR } from '../constants/dateTime';
export var isNewDay = function isNewDay(h, m) {
  var hours = Number(h);
  var minutes = Number(m);
  return hours >= 24 && minutes > 0;
};
export var isTimeOverload = function isTimeOverload(h, m, eH, eM) {
  var hours = Number(h);
  var minutes = Number(m);
  var endHours = Number(eH);
  var endMinutes = Number(eM);
  return hours > endHours || hours >= endHours && minutes > endMinutes;
};
export var addMinutes = function addMinutes(h, m, step) {
  var hours = Number(h);
  var minutes = Number(m);
  var newHours = hours;
  var newMinutes = minutes + step;
  if (newMinutes >= 60) {
    newHours = hours + Math.floor(newMinutes / 60);
    newMinutes = newMinutes % 60;
  }
  return [newHours < 10 ? "0".concat(newHours) : String(newHours), newMinutes < 10 ? "0".concat(newMinutes) : String(newMinutes)];
};

/**
 *
 * @param interval интервал времени в формате HH:mm
 * @param step шаг для итерации в минутах
 * @param callback
 */
export var timeForEach = function timeForEach(_ref, step, callback) {
  var start = _ref.start,
    end = _ref.end;
  var _start$split = start.split(TIME_SEPARATOR),
    _start$split2 = _slicedToArray(_start$split, 2),
    hours = _start$split2[0],
    minutes = _start$split2[1];
  var _end$split = end.split(TIME_SEPARATOR),
    _end$split2 = _slicedToArray(_end$split, 2),
    endHours = _end$split2[0],
    endMinutes = _end$split2[1];
  var newDay = false;
  var timeOverload = false;
  while (!newDay && !timeOverload) {
    var _addMinutes = addMinutes(hours, minutes, step),
      _addMinutes2 = _slicedToArray(_addMinutes, 2),
      newHours = _addMinutes2[0],
      newMinutes = _addMinutes2[1];
    newDay = isNewDay(newHours, newMinutes);
    timeOverload = isTimeOverload(newHours, newMinutes, endHours, endMinutes);
    if (!newDay && !timeOverload) {
      callback("".concat(hours, ":").concat(minutes));
      hours = newHours;
      minutes = newMinutes;
    }
  }
};